import type { ChatMessage } from '../../types';

export function renderToolCallStatus(status: 'calling' | 'done' | 'error') {
  if (status === 'done') {
    return <span className="driving-tool-call-icon driving-tool-call-icon-done">✓</span>;
  }
  if (status === 'error') {
    return <span className="driving-tool-call-icon driving-tool-call-icon-error">×</span>;
  }
  return <span className="driving-tool-call-spinner" aria-hidden="true" />;
}

export function resolveDrivingAssistantText(
  message: ChatMessage | undefined,
  currentAssistantMessageId: string | null | undefined,
  lastResponse: string,
): string {
  if (!message) return '';
  if (
    message.role === 'assistant'
    && message.id === currentAssistantMessageId
  ) {
    return lastResponse || message.content;
  }
  return message.content;
}
